const BalanceCardIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="37"
      height="35"
      viewBox="0 0 37 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.4375 8.65V4.375C34.4375 2.3125 32.75 0.625 30.6875 0.625H4.4375C2.35625 0.625 0.6875 2.3125 0.6875 4.375V30.625C0.6875 32.6875 2.35625 34.375 4.4375 34.375H30.6875C32.75 34.375 34.4375 32.6875 34.4375 30.625V26.35C35.5438 25.6937 36.3125 24.5125 36.3125 23.125V11.875C36.3125 10.4875 35.5438 9.30625 34.4375 8.65ZM32.5625 11.875V23.125H19.4375V11.875H32.5625ZM4.4375 30.625V4.375H30.6875V8.125H19.4375C17.375 8.125 15.6875 9.8125 15.6875 11.875V23.125C15.6875 25.1875 17.375 26.875 19.4375 26.875H30.6875V30.625H4.4375Z"
        fill={color}
      />
      <path
        d="M25.0625 20.3125C26.6158 20.3125 27.875 19.0533 27.875 17.5C27.875 15.9467 26.6158 14.6875 25.0625 14.6875C23.5092 14.6875 22.25 15.9467 22.25 17.5C22.25 19.0533 23.5092 20.3125 25.0625 20.3125Z"
        fill={color}
      />
    </svg>
  );
};

export default BalanceCardIcon;
